var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMCursos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_cursos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.05,53.05l-7.86-7.86v3.66A32.3,32.3,0,0,0,20.05,53.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.69,48.79V45.31L46.05,53A31.79,31.79,0,0,0,53.69,48.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.68,56.68l9,9a.4.4,0,0,0,.56,0l9.11-9.11a38.47,38.47,0,0,1-9.48,1.22A38.82,38.82,0,0,1,23.68,56.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.19,26.81.28,32.72a.4.4,0,0,0,0,.56l9.41,9.41V28.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.12,9.5l18.59,9.21L33.28.28a.4.4,0,0,0-.56,0L14.4,18.6,32.77,9.5A.43.43,0,0,1,33.12,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72l-5.94-5.94-3.59,1.77V42.81l9.53-9.53A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.73,24.38a.4.4,0,0,0,0,.72l3.46,1.71L14.4,18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.16,25.1a.41.41,0,0,0,0-.72L51.71,18.71l8.07,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.69,48.79A31.79,31.79,0,0,1,46.05,53l-3.66,3.66A38,38,0,0,0,56,50.15a.42.42,0,0,0,.16-.33v-7l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.19,48.85V45.19l-2.5-2.5v7.19a.42.42,0,0,0,.16.33,38.17,38.17,0,0,0,13.83,6.47l-3.63-3.63A32.3,32.3,0,0,1,12.19,48.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.05,53.05l3.63,3.63a38.82,38.82,0,0,0,9.23,1.15,38.47,38.47,0,0,0,9.48-1.22L46.05,53A37.34,37.34,0,0,1,20.05,53.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.78,26.78l-8.07-8.07L33.12,9.5a.43.43,0,0,0-.35,0L14.4,18.6,6.19,26.81l3.5,1.74V42.69l2.5,2.5V29.79l3.27,1.62v15.1a1.49,1.49,0,1,0,3,0V32.88L32.77,40a.36.36,0,0,0,.35,0L53.69,29.79V45.31l2.5-2.5V28.55Zm-26.84,10L21.75,31.21,26.4,28.9a16.41,16.41,0,0,0,6.75,1.18c4.57,0,9.91-1.34,9.91-5.13,0-2.36-2.59-5.13-9.91-5.13-4.57,0-9.91,1.35-9.91,5.13a3.48,3.48,0,0,0,.6,1.91L18.4,29.55,8.7,24.74l24.24-12,24.25,12ZM25.74,25c0-1.45,3.32-2.63,7.41-2.63S40.56,23.5,40.56,25s-3.31,2.63-7.41,2.63S25.74,26.4,25.74,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.69,48.79C42,57.52,24,57.54,12.19,48.85V29.79l3.27,1.62v15.1a1.49,1.49,0,1,0,3,0V32.88L32.77,40a.36.36,0,0,0,.35,0L53.69,29.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.94,36.75,21.75,31.21,26.4,28.9a16.41,16.41,0,0,0,6.75,1.18c4.57,0,9.91-1.34,9.91-5.13,0-2.36-2.59-5.13-9.91-5.13-4.57,0-9.91,1.35-9.91,5.13a3.48,3.48,0,0,0,.6,1.91L18.4,29.55,8.7,24.74l24.24-12,24.25,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.74,25c0-1.45,3.32-2.63,7.41-2.63S40.56,23.5,40.56,25s-3.31,2.63-7.41,2.63S25.74,26.4,25.74,25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCursos);
export default __webpack_public_path__ + "static/media/m_cursos.21b1f7371a756dacf54f499f85107700.svg";
export { ForwardRef as ReactComponent };